<template>

  <div
    :class="sidebarClasses"
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div
      id="style-3"
      class="sidebar-wrapper"
    >
      <div class="logo">
        <div class="simple-text" v-if="$root.attribute.name_company !== ''">
          <div class="logo-img">
            <img src="/web/img/logo.png" alt="Logo" >
          </div>
          {{ $root.attribute.name_company }}
        </div>

        <div class="simple-text" v-else>
          <div class="logo-img custom">
            <img :src="$root.attribute.logo_url" alt="Logo" >
          </div>
<!--          {{ $root.attribute.name_company }}-->
        </div>
      </div>
      <!-- user profile -->
      <user-profile-sidebar />
      <!-- end user profile -->

      <div class="sidebar_blocks">
        <div v-for="(block, block_key) in sidebar_blocks" class="sidebar_blocks__item">
          <p
              v-if="block.opened"
              class="title"
              @click="block.show = !block.show"
          >
            <span>
              {{ translate("sidebar." + block_key) }}
            </span>

            <i
                v-if="block.opened"
                class="mdi mdi-arrow-down"
                :class="{ reverse: block.show }"
            />
          </p>

          <div class="list" :class="{'show_block_list': block.show, 'block_list': block.opened}">
            <template v-for="(element) in block.list">
              <ul v-if="element[0].type === 'list'" :class="navClasses" >
                <li>
                  <router-link :to="update_path(element[0].path)" :class="{ router_link_exact_active: link_selection(element[0]) }">
                    <i class="mdi" :class="element[0].icon" />
                    <p :class="element[0].class" :title="element[0].title" >
                      {{ translate(element[0].name) }}
                    </p>
                  </router-link>
                </li>
              </ul>

              <v-tree
                  v-else-if="element[0].type === 'tree'"
                  :class="element[0].path !== '' ? 'menu_list_device' : 'menu_list_settings'"
                  :data="element"
                  :tpl='element[0].tpl'
              />
            </template>
          </div>

          <span
              v-if="check_delimiter(block_key, sidebar_blocks)"
              class="delimiter"
              :class="block.show ? 'mtop' : ''"
          />
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import UserProfileSidebar from './UserProfileSidebar.vue'
import links from "./links.json"

export default {
  components: {
    UserProfileSidebar
  },
  props: {
    type: {
      type: String,
      default: 'sidebar',
      validator: (value) => {
        let acceptedValues = ['sidebar', 'navbar']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: (value) => {
        let acceptedValues = ['white', 'black', 'darkblue']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
        return acceptedValues.indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      parents: {},
      device_nodes: {},
      simcard_devices_nodes: {},
      device_list: [],
      simcard_devices: [],
      settingsList: [],
      serversList: [],
      managementGroups: [],
      linkHeight: 60,
      activeLinkIndex: 0,
      sidebar_simcard_links: [],
      sidebar_common_links: [],
      dashboard_link: [],
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      child_links: {},

      sidebar_blocks: {}
    }
  },
  computed: {
    modules(){
      let modules = []
      Object.keys(this.$store.getters.getModules).forEach((block) => {
        modules.push(block)
        this.$store.getters.getModules[block].forEach((element) => {
          modules.push(block + "/" + element)
        })
      })
      return modules
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
    tickets_count(){
      return this.$store.getters.getTicketCount
    },
    sidebarClasses () {
      return this.type === 'sidebar' ? 'sidebar' : 'collapse navbar-collapse off-canvas-sidebar'
    },
    navClasses () {
      return this.type === 'sidebar' ? 'nav' : 'nav navbar-nav'
    },
    changes(){
        return {
          'tickets_count': this.$store.getters.getTicketCount,
          'lang': this.language,
          'childLinksDevice': this.$store.getters.getDeviceLinks,
          'deviceGroups': this.$store.getters.getDeviceGroups,
          'hideSidebarDevicesTree': this.$store.getters.getPermissions.hideSidebarDevicesTree,
          'childLinksSimcardDevices': this.$store.getters.getSimcardDevicesLinks,
          'childLinksSimcardProfile': this.$store.getters.getSimcardProfileLinks,
        }
    },
  },

  watch: {
    'changes':{
        deep: true,
        handler(){
            this.setLinks()
        }
    },
  },

  mounted () {
    this.setLinks()
  },

  methods: {
    update_path(path){
      if (path === "/invoice_list"){
        let today = new Date().setHours(0, 0, 0, 0)
        today = new Date(today).setDate(1)
        let date = new Date(today).setMonth(new Date(today).getMonth() - 1)
        let string = new Date(date).getFullYear() + "-" + ("0" + (new Date(date).getMonth() + 1)).slice(-2)
        return `${path}?date=${string}`
      }
      return path
    },
    check_delimiter(key, blocks){
      let block_keys = Object.keys(blocks)
      return block_keys.indexOf(key) !== (block_keys.length - 1)
    },
    link_selection(item){
      let path = item.path.replace('/', '')
      let fullPath = this.$route.fullPath.split('/');
      return path.indexOf(fullPath[1]) === 0;
    },
    scroll_bottom(){
      this.$nextTick(() => {
        let sidebar = this.$el.querySelector("#style-3")
        sidebar.scrollTop = sidebar.scrollHeight;
      })
    },

    main_tpl(...args) {
      let {0: node} = args
      let cross = ''
      if (node.close !== false) {
        cross = <span onClick={($event) => node.click(node, $event)} class="mdi mdi-close-box darksalmon" />
      }else if (node.children.length > 0) {
        cross = <span onClick={($event) => this.clearHistoryDevice(node, $event)} class="mdi mdi-close-circle darksalmon" />
      }
      node.icon = ''
      return <router-link custom key={node.path} to={node.path} class={node.class ? node.class : ''}>
          <i class={'mdi ' + node.icon} style="font-size: 24px;" />
          { node.tpl && node.type ? this.translate(node.name) : node.name }
          {cross}
      </router-link>
    },

    other_tpl(...args) {
      let {0: node} = args
      if (node.path === '') {
        return <span
          class={node.class ? node.class : ''}
          onClick={() => {
            setTimeout(this.scroll_bottom, 400)
            node.expanded = !node.expanded
          }}>
          <i
              class={'mdi ' + node.icon}
              style="font-size: 24px;"
          />
          { this.translate(node.name) }
        </span>
      }else{
        return <router-link custom key={node.path} to={node.path} class={node.class ? node.class : ''}>
            <i
                class={'mdi ' + node.icon}
                style="font-size: 24px;"
            />
            { this.translate(node.name) }
        </router-link>
      }
    },

    deleteLink(link, event, action, routeName, paramName, redirectPath) {
      event.preventDefault();
      this.$store.dispatch(action, {group: link.group, id: link.id});
      if (this.$route.name === routeName && this.$route.params[paramName] === link.id) {
        this.$router.push(redirectPath + '?group=' + link.group);
      }
    },

    deleteLinkDevices(link, event) {
      this.deleteLink(link, event, 'delete_link_device', 'device_section', 'device_id', '/device_list');
    },

    deleteLinkSimcardDevices(link, event) {
      this.deleteLink(link, event, 'deleteLinkSimcardDevices', 'simcard_devices_section', 'simcard_device_id', '/simcard_devices_list');
    },

    getChildGroup(link, ids = []) {
      if (link.children) {
        for (let i in link.children) {
          ids.push(+i);
          if (link.children[i].children) {
            this.getChildGroup(link.children[i], ids);
          }
        }
      }
      return ids;
    },

    deleteLinkGroup(link, event, nodeProperty, storeAction, routeNames, getItemById) {
      event.preventDefault();
      let ids = this.getChildGroup(this[nodeProperty][link.id], []);
      ids.push(+link.id);

      this.$store.dispatch(storeAction, { ids: ids, parent: link.parent });

      let redirect = false;

      if (routeNames.includes(this.$route.name) &&
          (ids.includes(+this.$route.params[routeNames[0]]) ||
              ids.includes(this.$store.getters[getItemById](this.$route.params[routeNames[1]]).profile.group_id))) {
        redirect = true;
      }

      if (redirect) {
        if (link.parent === undefined || +link.parent === -1) {
          this.$router.push('/');
        } else {
          this.$router.push(`${routeNames[2]}${link.parent}`);
        }
      }
      return true;
    },

    deleteLinkDevicesGroup(link, event) {
      return this.deleteLinkGroup(
          link,
          event,
          'device_nodes',
          'delete_link_group_device',
          ['device_list_group', 'device_id', '/device_list?group='],
          'getDeviceById'
      );
    },

    deleteLinkGroupSimcardDevices(link, event) {
      return this.deleteLinkGroup(
          link,
          event,
          'simcard_devices_nodes',
          'deleteLinkGroupSimcardDevices',
          ['simcard_list_group', 'simcard_devices_id', '/simcard_devices_list'],
          'getSimcardDevicesById'
      );
    },

    getGroup(groupGetter, groupId) {
      return this.$store.getters[groupGetter](groupId);
    },

    createNode(group, children, deleteFunction, pathPrefix) {
      return {
        id: group.id,
        parent: group.parent === undefined ? 0 : Number(group.parent),
        expanded: true,
        click: deleteFunction,
        name: this.getShortName(group.name, 20),
        title: group.name,
        path: `${pathPrefix}${group.id}`,
        icon: '',
        value: children.group ? { [children.id]: children } : {},
        children: children.group ? {} : { [children.id]: children }
      };
    },

    addLink(nodes, groupGetter, children, deleteFunction, pathPrefix) {

      let group_id = children.group ? children.group : children.parent
      let group = this.getGroup(groupGetter, group_id);

      if (group.status === 'unknw') {
        return false;
      }

      if (group.id !== -1 && !nodes[group.id]) {
        nodes[group.id] = this.createNode(group, children, deleteFunction, pathPrefix);
      }

      if (!nodes[group.id]) {
        nodes[group.id] = this.createNode(group, children, deleteFunction, pathPrefix);
      } else {
        if (children.group !== undefined) {
          nodes[group.id].value = { ...nodes[group.id].value, [children.id]: children };
        } else {
          if (nodes[group.id].children[children.id] === undefined) {
            nodes[group.id].children[children.id] = children;
          }
        }
      }

      if (+group.parent > -1) {
        let parentGroup = this.getGroup(groupGetter, group.parent, true);
        if (parentGroup.status === 'unknw') {
          nodes[group.id].parent = -1;
        } else {
          this.addLink(nodes, groupGetter, nodes[group.id], deleteFunction, pathPrefix);
        }
      }
    },

    addLinkDevices(children) {
      this.addLink(this.device_nodes, 'getDeviceGroupById', children, this.deleteLinkDevicesGroup, '/device_list?group=');
    },

    addLinkSimcardDevices(children) {
      this.addLink(this.simcard_devices_nodes, 'getSimcardDevicesGroupById', children, this.deleteLinkGroupSimcardDevices, '/simcard_devices_list?group=');
    },

    get_array_links(node) {
      let link = {...node};

      if (node.value){
        delete link.value

        link.children = Object.values(node.value)

        let children = Object.values(node.children)
        if (children){
          children.forEach((child) => {
            link.children.push(this.get_array_links(child))
          })
        }
      }

      return link
    },

    getShortName(name, maxLength) {
      return name.length > maxLength ? name.substr(0, maxLength - 2) + '...' : name;
    },

    processLinks(storeGetter, addLinkFunction, deleteLinkFunction, deleteLinkGroupFunction, getGroupById, pathPrefix, nodesProperty, hasGroup) {
      this[nodesProperty] = {};
      let list = this.$store.getters[storeGetter];
      Object.keys(list).forEach((group_id) => {
        let group = hasGroup ? list[group_id] : list;
        Object.keys(group).forEach((index) => {
          let item = group[index];
          addLinkFunction({
            id: index,
            click: deleteLinkFunction,
            name: this.getShortName(item.name, 18),
            group: hasGroup ? group_id : undefined,
            path: item.path,
            title: item.name,
            icon: item.icon
          });
        });

        if (hasGroup && group !== undefined && Object.keys(group).length === 0) {
          let group_info = this.$store.getters[getGroupById](group_id);
          this[nodesProperty][group_id] = {
            id: group_info.id,
            parent: group_info.parent === undefined ? 0 : Number(group_info.parent),
            expanded: true,
            click: deleteLinkGroupFunction,
            name: this.getShortName(group_info.name, 20),
            title: group_info.name,
            path: `${pathPrefix}${group_info.id}`,
            icon: '',
            value: {},
            children: {}
          };
          addLinkFunction(this[nodesProperty][group_id]);
        }
      });

      return Object.keys(this[nodesProperty]).map((node_id) => {
        if (!this[nodesProperty][node_id].parent || this[nodesProperty][node_id].parent === -1) {
          return this.get_array_links(this[nodesProperty][node_id]);
        }
      }).filter(link => link !== undefined);
    },

    clearHistoryDevice(link, event) {
      event.preventDefault()
      this.$store.dispatch('clear_history_device', {link: link})
      this.$router.push(link.path)
    },

    update_device_list(element){
      if (this.$store.getters.getPermissions.hideSidebarDevicesTree === true) return {...element, children : []}
      return {
        ...element,
        children: [
          ...this.processLinks(
            'getDeviceLinks',
            this.addLinkDevices,
            this.deleteLinkDevices,
            this.deleteLinkDevicesGroup,
            'getDeviceGroupById',
            '/device_list?group=',
            'device_nodes',
            true
          )
        ]
      }
    },

    update_simcard_devices_list(element){
      return {
        ...element,
        children: [
          ...this.processLinks(
            'getSimcardDevicesLinks',
            this.addLinkSimcardDevices,
            this.deleteLinkSimcardDevices,
            this.deleteLinkGroupSimcardDevices,
            'getSimcardDevicesGroupById',
            '/simcard_devices_list?group=',
            'simcard_devices_nodes',
            true
          )
        ]
      }
    },

    check_section(list){
      let fullPath = this.$route.fullPath.split('/');
      let selected_item = fullPath[1]
      let block = Object.values(list).find((item) => {
        if (item.type === "list"){
          if (item.path.replace('/', '') === selected_item) return item
        }else{
          if (item.children) {
            return item.children.find((children) => {
              if (children.path.replace('/', '') === selected_item) return children
            })
          }
        }
      })
      return !!block
    },

    createLinks() {
      let new_sidebar = {}

      Object.keys(links).forEach((block_key) => {
        let block = {...links[block_key]}
        let new_block = {
          opened: block.opened,
          show: this.check_section(block.list) ? this.check_section(block.list) : !block.opened,
          list: {}
        }

        Object.keys(block.list).forEach((item_key) => {
          let new_item = {...block.list[item_key]}
          if (new_item.type === "tree" && !new_item.children){
            new_item.tpl = this.main_tpl
          }else{
            new_item.tpl = this.other_tpl

            if (new_item.children) {
              new_item.children = new_item.children.filter((child) => {
                if (this.modules.indexOf(child.modules) > -1){
                  return child
                }
              })
            }
          }

          if (new_item.func){
            new_item = this[new_item.func](new_item)
          }

          if (this.modules.indexOf(new_item.modules) > -1){
            new_block.list[item_key] = [{...new_item}]
          }
        })

        if (Object.keys(new_block.list).length > 0){
          new_sidebar[block_key] = new_block
        }
      })
      this.sidebar_blocks = {...new_sidebar}
    },

    setLinks() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.createLinks, 500)
    }
  }
}

</script>
<style lang="scss" scoped>
.sidebar {
  .logo{
    .simple-text{
      .custom{
        width: 100%;
        margin-right: 0;
        border-radius: 0;
        background: none;

        img{
          max-width: none;
          width: auto;
          height: 100%;
        }
      }
    }
  }
}

.sidebar_blocks{
  &__item{
    position: relative;
    .title{
      width: 100%;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      color: #E3E3E3;
      text-transform: uppercase;
      font: 600 12px / 14px "Roboto", Arial, sans-serif;
      padding: 10px;
      margin-bottom: 0;

      .mdi-arrow-down {
        display: inline-block;
        transform: rotate(0);
        &.reverse::before {
          transform: rotate(180deg);
        }
      }
    }
    .list{
      transition: height 0.5s, all 0.2s;
      &.block_list{
        opacity: 0;
        height: 0;
        overflow: hidden;
      }
      &.show_block_list{
        opacity: 1;
        height: auto;
        overflow: visible;
      }
    }
    .delimiter{
      display: block;
      height: 1px;
      width: 100%;
      background-color: rgba(255, 255, 255, 0.3);
      &.mtop{
        margin-top: 10px;
      }
    }
  }
}

  .darksalmon {
    color: darksalmon;
  }
  .nav > li > a{
    padding: 10px 15px 0;
  }

  .router_link_exact_active{
    color: #41B883 !important;
    opacity: 1 !important;
  }

  @media (max-width: 991px){
    .off-canvas-sidebar{
      .nav{
        &>li{
          &>a{
            display: flex;
            align-items: center;
            .mdi{
              margin-right: 3px;
            }
            p{
              display: inherit !important;
            }
          }
        }
      }
    }
  }

</style>
